module.exports = __webpack_public_path__ + "img/icon-location.77a89eab.svg";